"use strict";

angular.module('rmRole')
    .factory('Role', require('./role.js'));
